const styles = theme => ({
    grow: {
      flexGrow: 1
    },
  
    toolbar: {
      borderBottom: `1px solid rgba(0, 0, 0, 0.12)`
    },
    
    accordionBody: {
      display: 'flex',
      alignItems: 'flex-start', 
      position: 'relative',
      justifyContent: 'space-between', 
      flexDirection: 'row',
    },

    content: {
      flexGrow: 1,
      overflow: 'hidden', 
      textAlign: 'left',
      '& h1, & h2, & h3, & h4, & h5, & h6': {
          fontSize: '1rem !important',
          color: '#1F2937 !important',
          margin: '8px 0 !important',
      },
      '& p': {
          fontSize: '0.9rem !important',
          lineHeight: '1.6 !important',
          marginBottom: '8px !important',
          color: '#4B5563 !important'
      }
    },
    blogListItem: {
        display: 'flex',
        alignItems: 'center',
        padding: '10px 16px',
        borderBottom: '1px solid #F1F3F9',
        backgroundColor: '#fff',
        transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#FBFBFF',
            boxShadow: '0 4px 15px rgba(13, 53, 89, 0.08)',
            transform: 'translateY(-2px)',
            zIndex: 1,
            '& $blogListTitle': {
                color: '#0d3559'
            }
        },
        '&:last-child': {
            borderBottom: 'none'
        }
    },
    blogListContent: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        marginRight: '20px'
    },
    blogListTitle: {
        fontWeight: 600,
        color: '#1F2937',
        fontSize: '0.85rem',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        transition: 'color 0.2s ease'
    },
    blogListTag: {
        fontSize: '0.55rem',
        fontWeight: 700,
        padding: '1px 6px',
        borderRadius: '3px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        marginBottom: '2px',
        width: 'fit-content'
    },
    blogListDate: {
        color: '#9CA3AF',
        fontSize: '0.75rem',
        fontWeight: 500,
        marginRight: '20px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
    },
    buttonContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-end',
      gap: '10px',
    },
    wrapper: {
        backgroundColor: '#fff',
        borderRadius: '8px',
        padding: theme.spacing(3),
        boxShadow: 'none',
        marginTop: 0
    },
    filterBar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: theme.spacing(3),
        gap: theme.spacing(2)
    },
    searchInput: {
        '& .MuiOutlinedInput-root': {
            borderRadius: '50px',
            backgroundColor: '#F8F9FE',
            width: '350px',
            '& fieldset': {
                borderColor: '#E9ECEF',
            },
            '&:hover fieldset': {
                borderColor: '#0d3559',
            },
        }
    },
    statusFilter: {
        borderRadius: '8px !important',
        backgroundColor: '#F8F9FE',
        minWidth: '150px',
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E9ECEF',
        }
    },
    tipsContainer: {
        backgroundColor: '#F8F9FE',
        borderRadius: '8px',
        border: '1px solid #E9ECEF',
        padding: theme.spacing(3),
        marginTop: theme.spacing(4)
    },
    accordionHeader: {
        '& .accordion-button': {
            backgroundColor: 'transparent !important',
            color: '#1F2937 !important',
            fontWeight: 600,
            boxShadow: 'none !important',
            borderBottom: '1px solid #F1F3F9',
            '&:not(.collapsed)': {
                backgroundColor: 'rgba(13, 53, 89, 0.05) !important'
            }
        }
    },
    listGrid: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: theme.spacing(3),
        margin: '0 -12px'
    },
    blogCard: {
        borderRadius: '12px',
        border: '1px solid #E9ECEF',
        marginBottom: '4px',
        backgroundColor: '#fff',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        cursor: 'pointer',
        position: 'relative',
        overflow: 'hidden',
        '&:hover': {
            boxShadow: '0 12px 25px rgba(13, 53, 89, 0.12)',
            borderColor: '#0d3559',
            '& $blogCardTitle': {
                color: '#0d3559'
            }
        }
    },
    blogCardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '16px'
    },
    blogCardIcon: {
        width: '40px',
        height: '40px',
        borderRadius: '8px',
        backgroundColor: 'rgba(13, 53, 89, 0.1)',
        color: '#0d3559',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '10px'
    },
    blogCardActions: {
        display: 'flex',
        gap: '4px'
    },
    blogCardTitle: {
        fontWeight: 700,
        color: '#1F2937',
        fontSize: '1rem',
        lineHeight: 1.4,
        margin: '20px 20px 12px 20px',
        display: '-webkit-box',
        '-webkit-line-clamp': 1,
        '-webkit-box-orient': 'vertical',
        overflow: 'hidden',
        height: '1.4em',
        transition: 'color 0.2s ease'
    },
    blogCardTag: {
        fontSize: '0.6rem',
        fontWeight: 700,
        padding: '2px 8px',
        borderRadius: '4px',
        backgroundColor: 'rgba(13, 53, 89, 0.08)',
        color: '#0d3559',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        width: 'fit-content',
        marginBottom: '16px'
    },
    blogCardFooter: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 'auto',
        padding: '16px 20px',
        backgroundColor: '#F8F9FE',
        borderTop: '1px solid #E9ECEF',
        color: '#9CA3AF',
        fontSize: '0.75rem',
        fontWeight: 500
    },
    footerItem: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px'
    }
  })
  
  export default styles
  